import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "mb-2" }
const _hoisted_2 = { class: "mb-2" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-3" }
const _hoisted_5 = {
  key: 0,
  class: "row mt-2 align-items-center"
}
const _hoisted_6 = { class: "col-4" }
const _hoisted_7 = { class: "col-4" }
const _hoisted_8 = { class: "col-4" }
const _hoisted_9 = { class: "mb-2" }
const _hoisted_10 = { class: "row mt-2 align-items-center" }
const _hoisted_11 = { class: "col-4" }
const _hoisted_12 = { class: "col-4" }
const _hoisted_13 = { class: "col-4" }
const _hoisted_14 = { class: "row mb-2" }
const _hoisted_15 = { class: "col-4" }
const _hoisted_16 = { class: "col-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Subtitle = _resolveComponent("Subtitle")!
  const _component_AdvancedColorEditor = _resolveComponent("AdvancedColorEditor")!
  const _component_InputTextEditor = _resolveComponent("InputTextEditor")!
  const _component_InputSelect = _resolveComponent("InputSelect")!
  const _component_CssDimensionEditor = _resolveComponent("CssDimensionEditor")!
  const _component_GenericComponentWrapper = _resolveComponent("GenericComponentWrapper")!

  return (_openBlock(), _createBlock(_component_GenericComponentWrapper, { componentUI: _ctx.componentUI }, {
    default: _withCtx(() => [
      _createElementVNode("div", null, [
        _createVNode(_component_Subtitle, {
          title: _ctx.$t('cms.overlayColor'),
          mb: "2"
        }, null, 8, ["title"]),
        _createVNode(_component_AdvancedColorEditor, {
          modelValue: _ctx.localDto.color,
          "onUpdate:modelValue": [
            _cache[0] || (_cache[0] = ($event: any) => ((_ctx.localDto.color) = $event)),
            _ctx.emitModelChanged
          ],
          isBackground: true,
          name: `${_ctx.name} ${_ctx.$t('cms.overlayColor')}`,
          errors: _ctx.errors
        }, null, 8, ["modelValue", "name", "errors", "onUpdate:modelValue"]),
        _createVNode(_component_Subtitle, {
          title: _ctx.$t('cms.overlayText'),
          mb: "2"
        }, null, 8, ["title"]),
        _createElementVNode("div", _hoisted_1, [
          _createVNode(_component_InputTextEditor, {
            modelValue: _ctx.localDto.text,
            "onUpdate:modelValue": [
              _cache[1] || (_cache[1] = ($event: any) => ((_ctx.localDto.text) = $event)),
              _ctx.emitModelChanged
            ],
            name: `${_ctx.name} ${_ctx.$t('cms.overlayText')}`,
            errors: _ctx.errors
          }, null, 8, ["modelValue", "name", "errors", "onUpdate:modelValue"])
        ]),
        _createVNode(_component_Subtitle, {
          title: _ctx.$t('cms.overlayPosition'),
          mb: "2"
        }, null, 8, ["title"]),
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_component_InputSelect, {
                modelValue: _ctx.localDto.position.position_type_code,
                "onUpdate:modelValue": [
                  _cache[2] || (_cache[2] = ($event: any) => ((_ctx.localDto.position.position_type_code) = $event)),
                  _ctx.onPositionTypeChanged
                ],
                options: _ctx.enumPositionTypeCode,
                name: `${_ctx.name} ${_ctx.$t('cms.overlayPositionType')}`,
                label: _ctx.$t('cms.overlayPositionType'),
                selectText: _ctx.$t('selectText'),
                errors: _ctx.errors
              }, null, 8, ["modelValue", "options", "name", "label", "selectText", "errors", "onUpdate:modelValue"])
            ])
          ]),
          (_ctx.showInsets)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _createVNode(_component_CssDimensionEditor, {
                    modelValue: _ctx.localDto.position.left,
                    "onUpdate:modelValue": [
                      _cache[3] || (_cache[3] = ($event: any) => ((_ctx.localDto.position.left) = $event)),
                      _ctx.emitModelChanged
                    ],
                    label: _ctx.$t('cms.overlayInsetLeft'),
                    name: `${_ctx.name} ${_ctx.$t('cms.overlayInsetLeft')}`,
                    errors: _ctx.errors,
                    "allow-disable": false,
                    "allow-empty-value": true
                  }, null, 8, ["modelValue", "label", "name", "errors", "onUpdate:modelValue"])
                ]),
                _createElementVNode("div", _hoisted_7, [
                  _createVNode(_component_CssDimensionEditor, {
                    modelValue: _ctx.localDto.position.top,
                    "onUpdate:modelValue": [
                      _cache[4] || (_cache[4] = ($event: any) => ((_ctx.localDto.position.top) = $event)),
                      _ctx.emitModelChanged
                    ],
                    label: _ctx.$t('cms.overlayInsetTop'),
                    name: `${_ctx.name} ${_ctx.$t('cms.overlayInsetTop')}`,
                    errors: _ctx.errors,
                    "allow-disable": false,
                    "allow-empty-value": true
                  }, null, 8, ["modelValue", "label", "name", "errors", "onUpdate:modelValue"]),
                  _createVNode(_component_CssDimensionEditor, {
                    modelValue: _ctx.localDto.position.bottom,
                    "onUpdate:modelValue": [
                      _cache[5] || (_cache[5] = ($event: any) => ((_ctx.localDto.position.bottom) = $event)),
                      _ctx.emitModelChanged
                    ],
                    label: _ctx.$t('cms.overlayInsetBottom'),
                    name: `${_ctx.name} ${_ctx.$t('cms.overlayInsetBottom')}`,
                    errors: _ctx.errors,
                    "allow-disable": false,
                    "allow-empty-value": true
                  }, null, 8, ["modelValue", "label", "name", "errors", "onUpdate:modelValue"])
                ]),
                _createElementVNode("div", _hoisted_8, [
                  _createVNode(_component_CssDimensionEditor, {
                    modelValue: _ctx.localDto.position.right,
                    "onUpdate:modelValue": [
                      _cache[6] || (_cache[6] = ($event: any) => ((_ctx.localDto.position.right) = $event)),
                      _ctx.emitModelChanged
                    ],
                    label: _ctx.$t('cms.overlayInsetRight'),
                    name: `${_ctx.name} ${_ctx.$t('cms.overlayInsetRight')}`,
                    errors: _ctx.errors,
                    "allow-disable": false,
                    "allow-empty-value": true
                  }, null, 8, ["modelValue", "label", "name", "errors", "onUpdate:modelValue"])
                ])
              ]))
            : _createCommentVNode("", true)
        ]),
        _createVNode(_component_Subtitle, {
          title: _ctx.$t('cms.overlayPadding'),
          mb: "2"
        }, null, 8, ["title"]),
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, [
              _createVNode(_component_CssDimensionEditor, {
                modelValue: _ctx.paddingDraft.left,
                "onUpdate:modelValue": [
                  _cache[7] || (_cache[7] = ($event: any) => ((_ctx.paddingDraft.left) = $event)),
                  _ctx.onPaddingChanged
                ],
                label: _ctx.$t('cms.overlayPaddingLeft'),
                name: `${_ctx.name} ${_ctx.$t('cms.overlayPaddingLeft')}`,
                errors: _ctx.errors,
                "allow-disable": false,
                "allow-empty-value": true,
                min: 0
              }, null, 8, ["modelValue", "label", "name", "errors", "onUpdate:modelValue"])
            ]),
            _createElementVNode("div", _hoisted_12, [
              _createVNode(_component_CssDimensionEditor, {
                modelValue: _ctx.paddingDraft.top,
                "onUpdate:modelValue": [
                  _cache[8] || (_cache[8] = ($event: any) => ((_ctx.paddingDraft.top) = $event)),
                  _ctx.onPaddingChanged
                ],
                label: _ctx.$t('cms.overlayPaddingTop'),
                name: `${_ctx.name} ${_ctx.$t('cms.overlayPaddingTop')}`,
                errors: _ctx.errors,
                "allow-disable": false,
                "allow-empty-value": true,
                min: 0
              }, null, 8, ["modelValue", "label", "name", "errors", "onUpdate:modelValue"]),
              _createVNode(_component_CssDimensionEditor, {
                modelValue: _ctx.paddingDraft.bottom,
                "onUpdate:modelValue": [
                  _cache[9] || (_cache[9] = ($event: any) => ((_ctx.paddingDraft.bottom) = $event)),
                  _ctx.onPaddingChanged
                ],
                label: _ctx.$t('cms.overlayPaddingBottom'),
                name: `${_ctx.name} ${_ctx.$t('cms.overlayPaddingBottom')}`,
                errors: _ctx.errors,
                "allow-disable": false,
                "allow-empty-value": true,
                min: 0
              }, null, 8, ["modelValue", "label", "name", "errors", "onUpdate:modelValue"])
            ]),
            _createElementVNode("div", _hoisted_13, [
              _createVNode(_component_CssDimensionEditor, {
                modelValue: _ctx.paddingDraft.right,
                "onUpdate:modelValue": [
                  _cache[10] || (_cache[10] = ($event: any) => ((_ctx.paddingDraft.right) = $event)),
                  _ctx.onPaddingChanged
                ],
                label: _ctx.$t('cms.overlayPaddingRight'),
                name: `${_ctx.name} ${_ctx.$t('cms.overlayPaddingRight')}`,
                errors: _ctx.errors,
                "allow-disable": false,
                "allow-empty-value": true,
                min: 0
              }, null, 8, ["modelValue", "label", "name", "errors", "onUpdate:modelValue"])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_14, [
          _createElementVNode("div", _hoisted_15, [
            _createVNode(_component_InputSelect, {
              modelValue: _ctx.localDto.content_vertical_position_code,
              "onUpdate:modelValue": [
                _cache[11] || (_cache[11] = ($event: any) => ((_ctx.localDto.content_vertical_position_code) = $event)),
                _ctx.emitModelChanged
              ],
              options: _ctx.enumVerticalPositionCode,
              canClear: true,
              label: _ctx.$t('cms.overlayContentVerticalPosition'),
              name: `${_ctx.name} ${_ctx.$t('cms.overlayContentVerticalPosition')}`,
              selectText: _ctx.$t('selectText'),
              errors: _ctx.errors
            }, null, 8, ["modelValue", "options", "label", "name", "selectText", "errors", "onUpdate:modelValue"])
          ]),
          _createElementVNode("div", _hoisted_16, [
            _createVNode(_component_InputSelect, {
              modelValue: _ctx.localDto.blend_mode_code,
              "onUpdate:modelValue": [
                _cache[12] || (_cache[12] = ($event: any) => ((_ctx.localDto.blend_mode_code) = $event)),
                _ctx.emitModelChanged
              ],
              options: _ctx.enumBlendModeCode,
              canClear: true,
              label: _ctx.$t('cms.overlayBlendMode'),
              name: `${_ctx.name} ${_ctx.$t('cms.overlayBlendMode')}`,
              selectText: _ctx.$t('selectText'),
              errors: _ctx.errors
            }, null, 8, ["modelValue", "options", "label", "name", "selectText", "errors", "onUpdate:modelValue"])
          ])
        ])
      ])
    ]),
    _: 1
  }, 8, ["componentUI"]))
}